import auth from '@client/components/auth';
import { resolveInfluencerId } from './resolveInfluencerId';

export const useCanModerateCommunity = (
  influencerId?: string | number,
): boolean => {
  if (auth.isAdministrator() || auth.isModerator()) return true;

  const own = resolveInfluencerId();
  return (
    auth.isInfluencer() &&
    own !== null &&
    resolveInfluencerId(influencerId) === own
  );
};
